import { createSlice } from '@reduxjs/toolkit';

import { getPrevNextIds } from '../../helpers/common';

import {
  addAnimalsToGroup,
  createLabel,
  deleteLabels,
  fetchLabel,
  fetchLabels,
  removeAnimalsFromGroup,
  updateGroup
} from '../actions/label';

const labelSlice = createSlice({
  name: 'label',
  initialState: {
    customGroupOptions: [],
    data: [],
    error: null,
    label: null,
    loading: false,
    options: [],
    sortedData: []
  },
  reducers: {
    setSortedData: (state, action) => {
      state.sortedData = action.payload;
    }
  },
  extraReducers: builder => {
    builder
      // Create Label
      .addCase(createLabel.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createLabel.fulfilled, (state, action) => {
        state.loading = false;
        state.label = action.payload;
      })
      .addCase(createLabel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Add Animals To Group
      .addCase(addAnimalsToGroup.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addAnimalsToGroup.fulfilled, (state, action) => {
        state.loading = false;
        // state.data = action.payload;
      })
      .addCase(addAnimalsToGroup.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch Labels
      .addCase(fetchLabels.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLabels.fulfilled, (state, action) => {
        state.data = action.payload.data;
        state.sortedData = action.payload.data;
        state.options = action.payload.options;
        state.customGroupOptions = action.payload.customGroupOptions;
        state.filterOptions = action.payload.filterOptions;
        state.loading = false;
      })
      .addCase(fetchLabels.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch Label
      .addCase(fetchLabel.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLabel.fulfilled, (state, action) => {
        const data = JSON.parse(JSON.stringify(state.sortedData));
        const { prev_id, next_id } = data?.length
          ? getPrevNextIds(data, action.payload?.id)
          : {
              prev_id: action.payload.prev_id,
              next_id: action.payload.next_id,
              collection: (action.payload?.collection || []).map(item => ({ label: item.name, value: item.id }))
            };
        state.label = { ...action.payload, prev_id, next_id };
        state.loading = false;
      })
      .addCase(fetchLabel.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update Label
      .addCase(updateGroup.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateGroup.fulfilled, (state, action) => {
        state.label = action.payload;
        state.loading = false;
      })
      .addCase(updateGroup.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete Labels
      .addCase(deleteLabels.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteLabels.fulfilled, (state, action) => {
        state.loading = false;
        state.list = state.list.filter(record => !action.payload?.includes(record.id));
      })
      .addCase(deleteLabels.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Remove animals from the group
      .addCase(removeAnimalsFromGroup.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeAnimalsFromGroup.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(removeAnimalsFromGroup.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { setSortedData } = labelSlice.actions;
export default labelSlice.reducer;
